<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "XingbieBili",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      var symbols = [
        "path://M104.57,246.54v-11.16l7.81-8.93h14.51l8.93,7.26v12.84l3.35,1.67v5.86l-1.23,3.91l-3.12,3.74v8.53l32.53,10.6l11.72,55.81v12l-5.58,32.37l-6.7,13.95l-2.79,5.02l2.51,61.4l5.3,28.19l4.47,45.21l2.79,34.88l8.65,10.88l1.95,8.65l-2.79,3.07h-13.67l-11.16-10.6l-4.47-21.21l-10.47-62.51l-20.23-70.33l-3.63,60.56l1.95,31.53l0.84,30.98l0.84,27.07l-8.09,5.02l-6.14,5.86l-16.47,1.4l-2.79-6.14l12.84-14.51L93.4,447.75l-5.02-44.09l-10.05-13.67l-2.79-21.49l-2.23-30.98l10.88-53.02c0,0,25.35-8.88,26.84-10.93s-0.05-9.72-0.05-9.72l-4.74-4.74l-3.07-7.53L104.57,246.54z",
        'path://M68.59,104.62A113,113,0,0,0,64.06,87a.81.81,0,0,0,0-1c-.34-.45-1.62-4.09-1.83-4.45s-.4-.6-.24-.71a5.65,5.65,0,0,1,1.37,0,.21.21,0,0,0,.12.05c.22,0,.32,0,.37-.05a4.14,4.14,0,0,0,1.27-.38.44.44,0,0,0,.68-.19c0-.1.06-.23.09-.36.57-.54.84-1.14,1.11-1.38a.7.7,0,0,0,.11-.32c.24.06.38,0,.38-.55a10.17,10.17,0,0,0-.17-2,2.21,2.21,0,0,0-.13-.23c0-.47,0-1,0-1.46a.56.56,0,0,0,.35.26c.4.07.64,0,.62-.2s-.39-1.11-.44-1.35a2.25,2.25,0,0,0-.62-.63c-.07-1.31-.14-2.31-.16-2.39-.05-.25.18-.93.08-1.11s0-.32,0-.51,0-.27-.3-.47a1,1,0,0,1-.31-.39c-.17-1.46-.58-6.41-.67-7.24s-.84-3.85-.82-4-.07,0-.18-.18,0-.29,0-.5a.26.26,0,0,0-.27-.31c-.14,0,0-.38,0-.49s-.14-.09-.24-.09,0-.12-.13-.4a9.8,9.8,0,0,0-.54-1.61A1.24,1.24,0,0,0,62.8,52c-.23,0-.25,0-1-.48A6.8,6.8,0,0,0,60,50.59c-.41-.09-.66-.56-1.31-.91s-2-1-2.34-1.14a3.34,3.34,0,0,1-.68-.5,3.37,3.37,0,0,0,.48-2.92c-.43-1.21.41-1.86.61-3.06a4.14,4.14,0,0,0-.4-2.18.81.81,0,0,0,.23-.48,2.53,2.53,0,0,1,.34-1,4.54,4.54,0,0,0,.33-1.13c.05-.29.53-1.38.14-1.68a.86.86,0,0,0-.29-.16.34.34,0,0,1,.29.16c.53-2.17-.64-5.14-1.53-6.64h0a2.94,2.94,0,0,0-2.47-2.14,2.65,2.65,0,0,0-.82,0c-.45,0-.74.22-1.06,0l-.16-.06a3.06,3.06,0,0,0-2.27-.19,4.32,4.32,0,0,0-1.68.83c-.18.09-.36.17-.51.26a8.27,8.27,0,0,0-2.5,2.6,5.74,5.74,0,0,0-1,2.36,6.21,6.21,0,0,0,.35,3.3l.08,0A8.05,8.05,0,0,0,43,37.25a1.47,1.47,0,0,0,.06.62c.08.11.2,0,.39.32s.22,1.56,1.34,2.1c0,0,.48,2.8,1.71,4.08a.57.57,0,0,1,0,.33s0,.08-.06.13h0c-.35,0-.43.65-.56.82a.85.85,0,0,1-.5.26c-.27.09-.07.4-1.89.57a12,12,0,0,0-3,.43,2.33,2.33,0,0,1-1.41.13,9.57,9.57,0,0,0-2.4.3c-.15,0-.23-.31-.45-.24a5.58,5.58,0,0,0-1.79,2.16A37,37,0,0,0,33,56.53c0,1.24-.49,5.47-.81,8.42a5.73,5.73,0,0,1-.48,1.31,2.92,2.92,0,0,0-.19.49.71.71,0,0,0,.05.52c.09.17.28.29.3.48h0l0,.16h0c0,.13-.12.25-.15.39A1,1,0,0,0,32,69c.11.16.21.33.31.51.19.52,0,1.45.16,2.75s4.44,2.65,4.44,2.65-.39,1.64-.62,3.08-2,7.09-2.25,7.94-.45,1.46-.45,1.46-.25,0,1.1,1h0c-.59,1.66-1.23,3.38-1.93,5.23C30.94,98.29,30,102,29.45,109.8c2.7,1.11,4.14,1.61,4.84,1.83l.61.47c0,.41,0,.72,0,.91,1.55.19,3.41.33,5.31.45,2.12,5.4,4.11,10.32,4.61,12.54.76,3.36.47,10.16,1.95,15.81.9,3.42,1.84,6.23,2.55,8.37a36.06,36.06,0,0,0-1.56,3.7c-.14.84,0,2.47-.08,3.38a13.74,13.74,0,0,0-.42,3.11,24.49,24.49,0,0,1-.39,3.19c0-.12-.13,0-.19.22,0,0-.12.63-.27,1.57a2.38,2.38,0,0,0,.5,2.39,9.9,9.9,0,0,0,2.86,1.9,1.14,1.14,0,0,0,.65.17c.07.85.64,1.57,1.54,2.71.39.49,1.11.61,2.69,0,2-.84,2.63-.58,2.84-1.62s-.3-4.83-.37-5.93a9.84,9.84,0,0,1,.52-3.47,4.56,4.56,0,0,0-.83-3.86,10.49,10.49,0,0,0-1.13-1.2h-.06a4,4,0,0,1-.49-1.17c-.12-.7-.46-5.43-.48-7.12,0-.37,0-1-.07-1.75l0-.11h0a51.38,51.38,0,0,0,2-6.31c1-4.24.85-10.77.91-14.12a59.22,59.22,0,0,1,2.16-11.52,11.71,11.71,0,0,0,2.27-.34c0-.34-.1-.73-.15-1.13a3,3,0,0,1,.91-.44c1.3-.16,3.5-.57,3.72-.62,1-.18,3.27-.45,3.42-.58a18.28,18.28,0,0,0-.38-2.7C69.38,108.06,68.67,105.08,68.59,104.62Zm-9.5-36.47c.08,0,.14.09.17.16a2.58,2.58,0,0,1,.3,1c0,.44-.19.91,0,1.3.1.19.28.32.35.52a1,1,0,0,1,0,.42c0,.19,0,.38,0,.58-.31,0-.64.08-1,.09a1.24,1.24,0,0,0-.3-.84,1.78,1.78,0,0,1-.22-.26.27.27,0,0,1,0-.31.54.54,0,0,1,.16-.1c.21-.13.24-.42.26-.67a5.07,5.07,0,0,1,.17-.88,1.44,1.44,0,0,0,.1-.5A4,4,0,0,1,59.09,68.15Zm-7.68,98.67c0-.08,0-.18,0-.27,0,.11,0,.21,0,.3Zm4.15-138.4a1.55,1.55,0,0,1,.1.27,1.91,1.91,0,0,0-.14-.21A4.19,4.19,0,0,0,53.62,27,2.8,2.8,0,0,1,55.56,28.42Zm-7.75-1.16a3.47,3.47,0,0,1,2.72-.57h0a7.49,7.49,0,0,0-2.72.57ZM44.1,36.13c0,.11.16.6.08.65A1.55,1.55,0,0,0,44,37h-.4A8,8,0,0,1,44.1,36.13Zm-.16,2.4c0-.5-.1-1,.26-1a4.92,4.92,0,0,1,0,.78c0,.45.23,1,.21,1.16S44,39.2,43.94,38.53Zm17.77,73.92.06,0v.39C61.74,112.73,61.72,112.59,61.71,112.45Z"'
      ];
      var bodyMax = 50;

      var labelSetting = {
        normal: {
          show: true,
          position: "bottom",
          offset: [8, 16],
          formatter: function(param) {
            return ((param.value / bodyMax) * 50).toFixed(1) + "%";
          },
          textStyle: {
            fontSize: 18,
            fontWeight: "bold",
            color: "#fff"
          }
        }
      };
      var option = {
        xAxis: {
          data: ["a", "b"],
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          show: false,
          max: bodyMax
        },
        grid: {
          left: "12%",
          right: "12%"
        },
        series: [
          {
            name: "typeA",
            type: "pictorialBar",
            symbolBoundingData: bodyMax,
            animationDuration: 2000,
            symbolClip: false,
            label: labelSetting,
            data: [
              {
                value: Math.round(
                  (this.chartData.men.count / this.chartData.total) * 100
                ),
                symbol: symbols[0],
                symbolSize: [40, 128],
                itemStyle: {
                  normal: {
                    color: "#27d0ff"
                  }
                }
              },
              {
                value: Math.round(
                  (this.chartData.women.count / this.chartData.total) * 100
                ),
                symbol: symbols[1],
                symbolSize: [34, 112],
                itemStyle: {
                  normal: {
                    color: "#ff553e"
                  }
                }
              }
            ],
            z: 10
          },
          {
            name: "full",
            type: "pictorialBar",
            symbolBoundingData: bodyMax,
            animationDuration: 0,
            data: [
              {
                value: 1,
                symbol: symbols[0],
                symbolSize: [40, 0],
                itemStyle: {
                  normal: {
                    color: "#105366"
                  }
                }
              },
              {
                value: 1,
                symbol: symbols[1],
                symbolSize: [34, 0],
                itemStyle: {
                  normal: {
                    color: "#662219"
                  }
                }
              }
            ]
          }
        ]
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
</style>
